import { c as _c } from "react/compiler-runtime";
import { useActiveGithubOrgForUserNonSuspense, useIsImpersonatingNonSuspense } from "@/hooks/useConnectedGithubOrgs";
import { useCodesmithLeftSidebarRedesignEnabledForOrg } from "@/hooks/useCodesmithSettings";
import { useCachedOrgFlag } from "./useCachedOrgFlag";
import { SIDEBAR_REDESIGN_STORAGE_KEY_PREFIX, type CodesmithSidebarVariant } from "./sidebarVariant";
export function useCachedSidebarRedesignEnabled(args) {
  return useCachedOrgFlag(SIDEBAR_REDESIGN_STORAGE_KEY_PREFIX, args);
}

/**
 * Resolves the sidebar variant for `orgName`: a viewer's own orgs read the
 * connected-installation flag; an impersonated org (absent from the viewer's
 * installations) reads codesmith-settings. Unknown resolves to the cached
 * value for the org, then `legacy`.
 */
export function useCodesmithSidebarVariant(orgName) {
  const $ = _c(4);
  const isImpersonating = useIsImpersonatingNonSuspense();
  const {
    codesmithLeftSidebarRedesignEnabled,
    codesmithEnabledKnown
  } = useActiveGithubOrgForUserNonSuspense();
  const impersonated = useCodesmithLeftSidebarRedesignEnabledForOrg(isImpersonating ? orgName : null);
  const t0 = isImpersonating ? impersonated.enabled : codesmithLeftSidebarRedesignEnabled;
  const t1 = isImpersonating ? impersonated.enabledKnown : codesmithEnabledKnown;
  let t2;
  if ($[0] !== orgName || $[1] !== t0 || $[2] !== t1) {
    t2 = {
      orgName,
      enabled: t0,
      enabledKnown: t1
    };
    $[0] = orgName;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const enabled = useCachedSidebarRedesignEnabled(t2);
  return enabled ? "redesign" : "legacy";
}